<template>
  <div id="app">
    <main class="df fdr jcc"  v-bind:class="{
      'inverted-colors': $store.getters['AUTH.colorMode']
    }">
    <!-- <main class="df fdr jcc inverted-colors"> -->
      <transition name="fade">
        <router-view />
      </transition>
    </main>
  </div>
</template>

<script>
import firebaseInstance from './util/firebase'
import router from "./router";

export default {
  name: "App",
  data() {
    return {
      a: 'b'
    };
  },
  props: [],
  components: {},
  methods: {
    invertedColors() {
      let path = this.$route.path
      let paths = [
        // '/account',
        // '/faq',
        // '/'
      ]
      if (paths.indexOf(path) > -1) {
        return true
      }
      return false
    },
    checkLoginStatus() {
      this.$store.dispatch('AUTH.authStateChange', {})
    },
  },
  computed: {},
  watch: {
  },
  created() {
    let currentPath = router.currentRoute.path
    console.log("* Loaded app root. Path:", currentPath)
    this.checkLoginStatus()
  }
};
</script>

<style lang="scss">
  @import "./styles/settings.scss";

  @font-face {
    font-family: "Nexa";
    font-weight: 300;
    src: url("../static/fonts/Nexa/Nexa-Light.otf")
  }

/*  @font-face {
    font-family: "Inter";
    src: url("../static/fonts/Inter/Inter-VariableFont_slnt,wght.ttf")
  }*/

  @font-face {
    font-family: "Inter";
    font-weight: 900;
    src: url("../static/fonts/Inter/static/Inter-Black.ttf")
  }

  @font-face {
    font-family: "Inter";
    font-weight: 800;
    src: url("../static/fonts/Inter/static/Inter-ExtraBold.ttf")
  }

  @font-face {
    font-family: "Inter";
    font-weight: 700;
    src: url("../static/fonts/Inter/static/Inter-Bold.ttf")
  }

  @font-face {
    font-family: "Inter";
    font-weight: 600;
    src: url("../static/fonts/Inter/static/Inter-SemiBold.ttf")
  }

  @font-face {
    font-family: "Inter";
    font-weight: 500;
    src: url("../static/fonts/Inter/static/Inter-Medium.ttf")
  }

  @font-face {
    font-family: "Inter";
    font-weight: 400;
    src: url("../static/fonts/Inter/static/Inter-Regular.ttf")
  }

  @font-face {
    font-family: "Inter";
    font-weight: 300;
    src: url("../static/fonts/Inter/static/Inter-Light.ttf")
  }

  @font-face {
    font-family: "Inter";
    font-weight: 200;
    src: url("../static/fonts/Inter/static/Inter-ExtraLight.ttf")
  }

  @font-face {
    font-family: "Inter";
    font-weight: 200;
    src: url("../static/fonts/Inter/static/Inter-Thin.ttf")
  }

  .main {
      background: $color-background;
  }

  p, a, button, h1, h2, h3, h4, h5, h6, h7, h8 {
      color: $color-white;
      font-family: 'Roboto';
  }

  body {
    height: 100% !important;
    /*overflow-x: hidden;*/

    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;


  }

  .inverted-colors {
    /*background: $color-white;*/
    background-color: #efeff0;

    p, a, button, h1, h2, h3, h4, h5, h6, h7, h8 {
        color: $color-black;
    }
  }
  .popup-shown {
    overflow: hidden;
  }
</style>











// WEBPACK FOOTER //
// src/App.vue